import { PlantingDTO } from "seedgreen-shared/dtos/PlantingDTO";
import { computed, ComputedRef, Ref } from "vue";
import { Position } from "geojson";
import { useI18n } from "vue-i18n";

// const { userPosition } = useUserPosition();

/**
 * Get a method for sorting plantings
 * @param methodKey
 * @returns PlantingSortMethod object
 */
export function usePlantingSortMethod(
	methodKey: Ref<PlantingSortMethodKey>,
): ComputedRef<PlantingSortMethod> {
	const { t } = useI18n();
	PlantingSortMethods.distance.label = t("lot-search.distance");
	PlantingSortMethods["wet-asc"].label =
		`${t("planting.wet-date")} (${t("common.ascending")})`;
	PlantingSortMethods["wet-dsc"].label =
		`${t("planting.wet-date")} (${t("common.descending")})`;
	PlantingSortMethods["harvest-asc"].label = `${t(
		"planting.harvest-date",
	)} (${t("common.ascending")})`;
	PlantingSortMethods["harvest-dsc"].label = `${t(
		"planting.harvest-date",
	)} (${t("common.descending")})`;
	return computed(() => PlantingSortMethods[methodKey.value]);
}

export interface PlantingSortMethod {
	fn: (
		a: PlantingDTO,
		b: PlantingDTO,
		userPosition: Position | undefined,
	) => number;
	label: string;
}
export const PlantingSortMethods = {
	distance: {
		label: "Distance",
		fn: (
			a: PlantingDTO,
			b: PlantingDTO,
			userPosition: Position | undefined,
		) => {
			return userPosition
				? (a.distanceTo(userPosition) ?? Infinity) -
						(b.distanceTo(userPosition) ?? Infinity)
				: 0;
		},
	},
	"wet-asc": {
		fn: (a: PlantingDTO, b: PlantingDTO) => {
			return a.wetDateCurrent > b.wetDateCurrent ? 1 : -1;
		},
		label: "Wet Date (Ascending)",
	},
	"wet-dsc": {
		fn: (a: PlantingDTO, b: PlantingDTO) => {
			return a.wetDateCurrent < b.wetDateCurrent ? 1 : -1;
		},
		label: "Wet Date (Descending)",
	},
	"harvest-asc": {
		fn: (a: PlantingDTO, b: PlantingDTO) => {
			return a.harvestDates[0] > b.harvestDates[0] ? 1 : -1;
		},
		label: "Harvest Date (Ascending)",
	},
	"harvest-dsc": {
		fn: (a: PlantingDTO, b: PlantingDTO) => {
			return a.harvestDates[0] < b.harvestDates[0] ? 1 : -1;
		},
		label: "Harvest Date (Descending)",
	},
};
export type PlantingSortMethodKey = keyof typeof PlantingSortMethods;
